import { useModalStore } from '@/state/useModalStore';
import { SingletonMetric } from '../Form/SingletonMetric';

export default function SingletonModal() {
  // const closeModal = useModalStore((state) => state.closeModal);

  const modalData = useModalStore((state) => {
    if (state.modalType === 'SINGLE_METRIC') return state.modalData;
    return null;
  });

  //   const metricId = modalData.metricId;

  //   const [name, setName] = useState("");

  //   useEffect(() => {
  //     // TypeScript perfectly understands that modalData has 'defaultName' and 'userId' here
  //     if (modalData) {
  //       setName(modalData.defaultName);
  //     }
  //   }, [modalData]);

  if (!modalData) return null; // Defensive safety check

  return <SingletonMetric metricId={modalData.metricId} />;
}
